// react-pwa/src/LanguageContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import i18n from 'i18next';
import Cookies from 'js-cookie';

const LanguageContext = createContext();
const LANGUAGE_COOKIE_KEY = 'preferred_language';

export const LanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState(i18n.language);
    const [isInitialized, setIsInitialized] = useState(false);

    useEffect(() => {
        const initializeLanguage = () => {
            // Check if language preference exists in cookies
            const cookieLanguage = Cookies.get(LANGUAGE_COOKIE_KEY);
            
            console.log('🌐 Language initialization debug:');
            console.log('- navigator.language:', navigator.language);
            console.log('- cookieLanguage:', cookieLanguage);
            
            if (cookieLanguage) {
                console.log('- Using cookie language:', cookieLanguage);
                changeLanguage(cookieLanguage);
            } else {
                // Get browser's language (returns language code like 'en-US' or 'de-DE')
                const browserLang = navigator.language.toLowerCase().split('-')[0];
                // Set to German if browser language is German, otherwise default to English
                const detectedLanguage = browserLang === 'de' ? 'de' : 'en';
                console.log('- browserLang extracted:', browserLang);
                console.log('- detectedLanguage:', detectedLanguage);
                changeLanguage(detectedLanguage);
            }
            setIsInitialized(true);
        };

        if (!isInitialized) {
            initializeLanguage();
        }
    }, [isInitialized]);

    const changeLanguage = (lang) => {
        setLanguage(lang);
        i18n.changeLanguage(lang);
        // Store language preference in cookie
        Cookies.set(LANGUAGE_COOKIE_KEY, lang, { expires: 365 }); // Expires in 1 year
    };

    useEffect(() => {
        const handleLanguageChange = (lng) => setLanguage(lng);
        i18n.on('languageChanged', handleLanguageChange);
        return () => {
            i18n.off('languageChanged', handleLanguageChange);
        };
    }, []);

    if (!isInitialized) {
        return null; // Or a loading spinner if you prefer
    }

    return (
        <LanguageContext.Provider value={{ language, changeLanguage }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => useContext(LanguageContext);
